import React, {useState} from "react";
import {mainMobileTextCss, mainTextCss} from "../css/Main.style";
import {useNavigate} from "react-router-dom";
import Alert from "../../layouts/modal/Alert";

const MobileText = () => {



    const navigate = useNavigate();

    const [showAlert, setShowAlert] = useState<false | "login" | "already" | "waiting" | "deactivated">(false);

    const [authorStatus, setAuthorStatus] = useState<string | null>(null);

    const handleClick = () => {
        const currentStatus = localStorage.getItem("authorStatus");
        if (!currentStatus || currentStatus === "null" || currentStatus === "undefined") {
            setShowAlert("login");
        } else {
            const status = currentStatus.toLowerCase();
            if (status === "author" || status === "active") {
                setShowAlert("already");
            } else if (status === "hold") {
                setShowAlert("deactivated");
            } else if (status === "pending" || status === "w") {
                setShowAlert("waiting");
            } else {
                navigate("/addAuthor");
            }
        }
    };


    return(

        <>

            <div css={mainMobileTextCss}>
                <div className="subText">
                    <span>당신의 이야기를 독자에게 들려주세요.</span>
                </div>
                <div className={"subText2"}>
                    <p>작가로서 나를 소개하고,</p>
                    <p>독자와 글로 만나는 시간을 가져 보세요!</p>
                </div>

                <div className={" mt-[10px] flex items-center justify-center"}>
                    <button onClick={handleClick}
                            className="w-[118px] h-[36px]  rounded-[30px]  bg-main  "
                            style={{ boxShadow: '0 4px 8px 0 rgba(0, 128, 96, 0.25)' }}
                    >
                        <span className="text-white text-xs font-extrabold leading-none">작가 등록하기</span>
                    </button>
                </div>

                {showAlert && (
                    <Alert
                        title="알림"
                        message={
                            showAlert === "login"
                                ? "로그인이 필요합니다."
                                : showAlert === "already"
                                ? "이미 작가로 등록되어있어요!\n작가님의 다양한 작품 활동 소식을 많이 알려주세요 :)"
                                : showAlert === "deactivated"
                                ? "이미 작가로 등록되어있습니다."
                                : "이미 작가 등록 신청을 해주셨어요!\n운영진이 꼼꼼하게 검토하고 빠르게 안내해 드릴게요."
                        }
                        onClose={() => setShowAlert(false)}
                    />
                )}


            </div>

        </>



        )


}

export default MobileText;



